import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-1/6 border-r h-[100vh]" }
const _hoisted_2 = { class: "ml-4" }

import {i18n} from "@/utils/i18n";
import {ref, watch} from "vue";
import Profile from "@/components/layout/Profile.vue";
import {cn} from "@/utils/utils";
import Nav, {LinkProp} from "@/components/layout/Nav.vue";
import {ResizablePanelGroup, ResizablePanel} from "@/components/ui/resizable";
import {Separator} from "@/components/ui/separator";
import {TooltipProvider} from "@/components/ui/tooltip";

interface MenuProps {
  defaultLayout?: number[]
  defaultCollapsed?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Menu',
  props: {
    defaultLayout: { default: () => [265, 440, 655] },
    defaultCollapsed: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const isCollapsed = ref(props.defaultCollapsed)

const version = process.env.VUE_APP_VERSION;

const linksTable: LinkProp[] = [
  {
    title: i18n.global.t('menu.functions.title'),
    icon: 'lucide:users',
    to: { name: 'usersTable'},
    variant: 'ghost',
    root: 'yes',
  },
  {
    title: i18n.global.t('menu.dashboard'),
    icon: 'lucide:layout-dashboard',
    to: { name: 'dashboard'},
    variant: 'default',
    root:'none'
  },
  {
    title: i18n.global.t('menu.buildings'),
    icon: 'lucide:building',
    to: { name: 'buildingsTable'},
    variant: 'ghost',
    root:'none'
  },
  {
    title: i18n.global.t('menu.service_order'),
    icon: 'lucide:clipboard-list',
    to: { name: 'serviceOrdersTable'},
    variant: 'ghost',
    root:'none'
  },
  {
    title: i18n.global.t('menu.tables'),
    icon: 'lucide:users',
    to: { name: 'usersTable'},
    variant: 'ghost',
    root: 'yes',
  },
  {
    title: i18n.global.t('menu.users'),
    icon: 'lucide:users',
    to: { name: 'usersTable'},
    variant: 'ghost',
    root:'none'
  },
  {
    title: i18n.global.t('menu.managers'),
    icon: 'lucide:briefcase-business',
    to: { name: 'managersTable'},
    variant: 'ghost',
    root:'none'
  },
  {
    title: i18n.global.t('menu.masters'),
    icon: 'lucide:key',
    to: { name: 'mastersTable'},
    variant: 'ghost',
    root:'none'
  },
  {
    title: i18n.global.t('menu.coverage_elements'),
    icon: 'lucide:layers-3',
    to: { name: 'coverageElementsTable'},
    variant: 'ghost',
    root:'none'
  },
  {
    title: i18n.global.t('menu.defects'),
    icon: 'lucide:construction',
    to: { name: 'defectsTable'},
    variant: 'ghost',
    root:'none'
  },
  {
    title: i18n.global.t('menu.matrix'),
    icon: 'lucide:grid-2x2',
    to: { name: 'matrixTable'},
    variant: 'ghost',
    root:'none'
  },
  {
    title: i18n.global.t('menu.folders'),
    icon: 'lucide:folder',
    to: { name: 'foldersManage'},
    variant: 'ghost',
    root:'none'
  },
  {
    title: i18n.global.t('menu.other'),
    icon: 'lucide:users',
    to: { name: 'usersTable'},
    variant: 'ghost',
    root: 'yes',
  }
]

function onCollapse() {
  isCollapsed.value = true
}

function onExpand() {
  isCollapsed.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TooltipProvider), { "delay-duration": 0 }, {
      default: _withCtx(() => [
        _createVNode(_unref(ResizablePanelGroup), {
          id: "resize-panel-group-1",
          direction: "horizontal",
          class: "h-full max-h-[800px] items-stretch"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ResizablePanel), {
              id: "resize-panel-1",
              "default-size": _ctx.defaultLayout[0],
              "collapsed-size": 4,
              collapsible: "",
              "min-size": 15,
              "max-size": 20,
              class: _normalizeClass(_unref(cn)(isCollapsed.value && 'min-w-[950px] transition-all duration-300 ease-in-out')),
              onExpand: onExpand,
              onCollapse: onCollapse
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_unref(cn)('flex h-[52px] items-center ml-4', isCollapsed.value ? 'h-[52px]' : 'px-0'))
                }, [
                  _createVNode(Profile)
                ], 2),
                _createVNode(_unref(Separator)),
                _createElementVNode("span", _hoisted_2, "Software V.: " + _toDisplayString(_unref(version)), 1),
                _createVNode(_unref(Separator)),
                _createVNode(Nav, {
                  "is-collapsed": isCollapsed.value,
                  links: linksTable
                }, null, 8, ["is-collapsed"])
              ]),
              _: 1
            }, 8, ["default-size", "class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})